namespace Portico.Services {

	import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;

	import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import pmi = Portico.Models.Interfaces;
	import pms = Portico.Models.Setup;
	import ps = Portico.Services;

    export interface IDemoService {
		edit(id: string): angular.IPromise<boolean>;
		remove(portal: pms.Portal): angular.IPromise<boolean>;
		save(demo: pms.Demo): angular.IPromise<pms.Portal>;
	}

	// temporarily renamed portico service; created data service to avoid circular injection issues
    @Service('app', 'demoService')
    @Inject('$q', 'Upload', 'dataService', 'serverConstants', 'setupService')
	export class DemoService implements IDemoService {

        constructor(
			private $q: angular.IQService,
			private $upload: any,
			private dataService: ps.IDataService,
			private serverConstants: pmi.IServerConstants,
			private setupService: ps.ISetupService
        ) { }

		edit(id: string): angular.IPromise<boolean> {
			const promise =
				id !== pm.GUID_EMPTY ?
				this.setupService.portalService.getDetailsById(id, false) :
				this.$q.when(new pms.Portal());

			return promise.then((response) => {
				if (!response.id) {
					response.coreVersion = '1.0';
					response.portalGroupId = pm.PORTAL_GROUP_DEMO;
					response.settings = 
					`{
						"head": [
							"<link rel='stylesheet' href='https://static.trialcard.com/bootstrap/3.3.7/css/bootstrap.min.css' />",
							"<script src='/App/Release/\${CORE}/portico-vendor-\${CORE}.min.js?b=\${BUILD}'></script>",
							"<script src='/App/Release/\${CORE}/portico-core-\${CORE}.min.js?b=\${BUILD}'></script>",
							"<script src='/App/Release/\${CORE}/Configurations/1/StateConfig.js?b=\${BUILD}'></script>",
							"<script src='https://static.trialcard.com/bootstrap/3.3.7/js/bootstrap.min.js'></script>"
						]
					}`;
					response.url = 'demo';

					// Standard Default
					response.portalDataGroups.push(new pms.PortalDataGroup(<pms.IPortalDataGroup>{
						dataGroupId: pm.DATA_GROUP_STANDARD_DEFAULT,
						priority: 1
					}));

					// Template Placeholder
					response.portalDataGroups.push(new pms.PortalDataGroup(<pms.IPortalDataGroup>{
						priority: 2
					}));

					// Private
					const component = this.dataService.getDataTable('Component');
					const componentHtml = component.getDataColumn('Html');

					const image = this.dataService.getDataTable('Image');
					const imageSource = image.getDataColumn('Source');

					const reference = this.dataService.getDataTable('Reference');
					const referenceId = reference.getDataColumn('Id');

					response.portalDataGroups.push(new pms.PortalDataGroup(<pms.IPortalDataGroup>{
						priority: 9,
						dataGroup: new pms.DataGroup(<pms.IDataGroup>{
							dataGroupTypeId: pm.DATA_GROUP_TYPE_PORTAL,
							name: '',
							isPrivate: true,
							dataRows: [
								new pms.DataRow(<pms.IDataRow>{
									key: 'brand-name',
									dataTableId: component.id,
									dataValues: [
										new pms.DataValue(<pms.IDataValue>{
											dataColumnId: componentHtml.id
										})
									]
								}),
								new pms.DataRow(<pms.IDataRow>{
									key: 'color-background',
									dataTableId: reference.id,
									dataValues: [
										new pms.DataValue(<pms.IDataValue>{
											dataColumnId: referenceId.id,
											value: '#FFFFFF'
										})
									]
								}),
								new pms.DataRow(<pms.IDataRow>{
									key: 'color-font',
									dataTableId: reference.id,
									dataValues: [
										new pms.DataValue(<pms.IDataValue>{
											dataColumnId: referenceId.id,
											value: '#444444'
										})
									]
								}),
								new pms.DataRow(<pms.IDataRow>{
									key: 'color-primary',
									dataTableId: reference.id,
									dataValues: [
										new pms.DataValue(<pms.IDataValue>{
											dataColumnId: referenceId.id
										})
									]
								}),
								new pms.DataRow(<pms.IDataRow>{
									key: 'color-secondary',
									dataTableId: reference.id,
									dataValues: [
										new pms.DataValue(<pms.IDataValue>{
											dataColumnId: referenceId.id
										})
									]
								}),
								new pms.DataRow(<pms.IDataRow>{
									key: 'brand-logo',
									dataTableId: image.id,
									dataValues: [
										new pms.DataValue(<pms.IDataValue>{
											dataColumnId: imageSource.id
										})
									]
								}),
								new pms.DataRow(<pms.IDataRow>{
									key: 'template-id',
									dataTableId: reference.id,
									dataValues: [
										new pms.DataValue(<pms.IDataValue>{
											dataColumnId: referenceId.id
										})
									]
								}),
								new pms.DataRow(<pms.IDataRow>{
									key: 'tenant-name',
									dataTableId: component.id,
									dataValues: [
										new pms.DataValue(<pms.IDataValue>{
											dataColumnId: componentHtml.id
										})
									]
								})
							]
						})
					}));
				}

				const squares = response.portalDataGroups.filter((portalDataGroup) => {
					return portalDataGroup.dataGroupId.toUpperCase() === pm.DATA_GROUP_LNF_SQUARE;
				});

				const shadows = response.portalDataGroups.filter((portalDataGroup) => {
					return portalDataGroup.dataGroupId.toUpperCase() === pm.DATA_GROUP_LNF_SHADOW;
				});

				this.dataService.setup.demo = new pms.Demo();
				this.dataService.setup.demo.portal = response;
				this.dataService.setup.demo.brand = this.getDataValue(response, 'Component', 'Html', 'brand-name');
				this.dataService.setup.demo.logo = this.getDataValue(response, 'Image', 'Source', 'brand-logo');
				this.dataService.setup.demo.pharma = this.getDataValue(response, 'Component', 'Html', 'tenant-name');
				this.dataService.setup.demo.primary = this.getDataValue(response, 'Reference', 'Id', 'color-primary');
				this.dataService.setup.demo.secondary = this.getDataValue(response, 'Reference', 'Id', 'color-secondary');
				this.dataService.setup.demo.shadow = shadows.length > 0;
				this.dataService.setup.demo.square = squares.length > 0;
				this.dataService.setup.demo.template = this.getDataValue(response, 'Reference', 'Id', 'template-id');

				this.dataService.setup.demo.primary.value = this.dataService.setup.demo.primary.value.toLowerCase();
				this.dataService.setup.demo.secondary.value = this.dataService.setup.demo.secondary.value.toLowerCase();
				this.dataService.setup.demo.template.value = this.dataService.setup.demo.template.value.toLowerCase();

				// why not just return the demo portal?
				// can the action service return data?

				return true;
			});
		}

		remove(portal: pms.Portal): angular.IPromise<boolean> {
			return this.setupService.portalService.getDetailsById(portal.id).then((details) => {
				return this.setupService.portalService.delete(portal).then((response) => {
					if (this.dataService.setup.demos) {
						this.dataService.setup.demos = this.dataService.setup.demos.filter((p) => {
							return p.id !== portal.id;
						});
					}

					if (this.dataService.setup.templates) {
						this.dataService.setup.templates = this.dataService.setup.templates.filter((p) => {
							return p.id !== portal.id;
						});
					}

					const promises: angular.IPromise<any>[] = [];

					details.portalDataGroups.forEach((portalDataGroup) => {
						if (portalDataGroup.dataGroup.isPrivate) {
							promises.push(this.setupService.dataGroupService.delete(portalDataGroup.dataGroup));
						}
					});

					return this.$q.all(promises).then(() => {
						return response;
					});
				});
			});
		}

		// rename to saveDemo?  move into a demo service?
		save(demo: pms.Demo): angular.IPromise<pms.Portal> {
			this.dataService.setup.demo.primary.value = this.dataService.setup.demo.primary.value.toUpperCase();
			this.dataService.setup.demo.secondary.value = this.dataService.setup.demo.secondary.value.toUpperCase();
			this.dataService.setup.demo.template.value = this.dataService.setup.demo.template.value.toUpperCase();

			// set path to logo file
			if (demo.logoFile) {
				demo.logo.value = '{{$app.serverConstants.contentPath}}/Demo/' + demo.logoFile.name;
			}

			// remove shadow and square
			demo.portal.portalDataGroups = demo.portal.portalDataGroups.filter((portalDataGroup) => {
				return portalDataGroup.dataGroupId.toUpperCase() !== pm.DATA_GROUP_LNF_SHADOW && portalDataGroup.dataGroupId.toUpperCase() !== pm.DATA_GROUP_LNF_SQUARE;
			});

			// if checked, add square
			if (this.dataService.setup.demo.square) {
				demo.portal.portalDataGroups.push(new pms.PortalDataGroup(<pms.IPortalDataGroup>{
					dataGroupId: pm.DATA_GROUP_LNF_SQUARE,
					priority: 3
				}));
			}

			// if checked, add shadow
			if (this.dataService.setup.demo.shadow) {
				demo.portal.portalDataGroups.push(new pms.PortalDataGroup(<pms.IPortalDataGroup>{
					dataGroupId: pm.DATA_GROUP_LNF_SHADOW,
					priority: 4
				}));
			}

			demo.portal.portalDataGroups.forEach((pdg) => {
				// don't save shared data groups (1-4)
				if (pdg.priority <= 4) {
					pdg.dataGroup = null;
				}

				// set template data group
				if (pdg.priority === 2) {
					pdg.dataGroupId = this.getDataValue(demo.portal, 'Reference', 'Id', Portico.Models.KnownKeyNames.templateId).value;
				}

				// set template data group
				if (pdg.priority === 9) {
					pdg.dataGroup.name = demo.portal.name + ' (private)';
				}
			});

			return this.setupService.portalService.saveDetails(demo.portal).then((response) => {
				if (demo.logoFile) {
					this.$upload.upload({
						url: this.serverConstants.root + 'Setup/Upload',
						data: { file: demo.logoFile }
					}).success(function (data, status, headers, config) {
						// console.log(data);
					}).error(function (data, status, headers, config) {
						// console.log(data);
					});
				}

				return response;
			});
		}

		private getDataValue(portal: pms.Portal, table: string, column: string, key: string): pms.DataValue {
			const dataTable = this.dataService.getDataTable(table);
			const dataColumn = dataTable.getDataColumn(column);
			const dataRows = portal.getDataRows(dataTable.id, key);
			const dataRow = dataRows[0];
			const dataValue = dataRow.getDataValue(dataColumn.id);

			return dataValue;
		}
    }
}